<template>
  <div class="yx-student-info-detail-page yx-handle-common-page">
    <el-card class="box-form">
      <c-title slot="header" :title="'信息详情'"></c-title>
      <student-info :id="id" :jxfFlag="true" :familyFlag="true"></student-info>
    </el-card>
  </div>
</template>

<script>
import StudentInfo from "@/components/StudentInfo/index.vue";
export default {
  components: {
    StudentInfo,
  },
  data() {
    return {
      currentTab: "first",
      title: "",
      studentId: "",
      id: "",
      idCard: "",
    };
  },
  created() {
    this.id = this.$route.params.id;
    // this.studentId = this.$route.query.studentId;
    // this.idCard = this.$route.params.idCard;
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
};
</script>
